import React from 'react';
import Status from "../Status";
import { WaitForApplicationData } from "../../../ApplicationDataLoader";
var LegacyCheckboxes = function LegacyCheckboxes(_ref) {
  var application = _ref.application,
    hasPermission = _ref.hasPermission,
    info = _ref.info,
    onActionClick = _ref.onActionClick,
    onActionClickNoSweetAlert = _ref.onActionClickNoSweetAlert,
    onReadyForVisa = _ref.onReadyForVisa,
    onReadyToSubmit = _ref.onReadyToSubmit,
    onSubmittedToSchool = _ref.onSubmittedToSchool,
    reloadAggregatedData = _ref.reloadAggregatedData,
    ProcessDeferralModal = _ref.ProcessDeferralModal;
  return /*#__PURE__*/React.createElement(WaitForApplicationData, null, /*#__PURE__*/React.createElement(Status, {
    onSubmittedToSchool: onSubmittedToSchool,
    hasPermission: hasPermission,
    application: application,
    info: info,
    onActionClick: onActionClick,
    onActionClickNoSweetAlert: onActionClickNoSweetAlert,
    onReadyToSubmit: onReadyToSubmit,
    onReadyForVisa: onReadyForVisa,
    reloadAggregatedData: reloadAggregatedData,
    ProcessDeferralModal: ProcessDeferralModal
  }));
};
export default /*#__PURE__*/React.memo(LegacyCheckboxes);